import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Box, Typography } from "@dealer-center/core-components";
import {
  OemElement,
  SI_OEM_COMPLIANCE_TAG
} from "@dealer-center/core-custom-components";
import { useCC9Flags } from "@dealer-center/core-third-party-launch-darkly";
import { useSystemStore } from "@dealer-center/ddc-state-system";

/**
 * The OEM Compliance Center is a web component published by the Site Intelligence UI and
 * loaded from its own origin at runtime. This page supplies the loader URL for the current
 * environment and nothing else: the bundle carries its own environment, API base URL and
 * build version, so there is no attribute for this page to set and no way for it to point the
 * element at the wrong environment.
 */
export const PagesOemComplianceCenterUiDisplay = () => {
  const { config } = useSystemStore();
  const { "ddc.oem-compliance-center.enable": isEnabled } = useCC9Flags();

  useEffect(() => {
    document.title = "OEM Compliance Center";
  }, []);

  // `!== true`, not `=== false`: `undefined` means LaunchDarkly has not answered yet, and this
  // page must not render in that window. Hiding the nav item is not enough on its own — the
  // route is reachable by typing the URL.
  if (isEnabled !== true) return <Navigate replace to="/" />;

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
        <Typography variant={"h1"}>OEM Compliance Center</Typography>
      </Box>
      {/* No `session`: the token contract with the OEM platform is not settled yet, so the
          element runs anonymous. Its screens and chrome still render. */}
      <OemElement
        loaderUrl={config.oemComplianceLoaderUrl}
        tagName={SI_OEM_COMPLIANCE_TAG}
      />
    </Box>
  );
};
